import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import { withMinimalLoading } from '../../services/withMinimalLoading';

import { preferencesApi } from './api';
import { preferencesQueryKey } from './preferencesQueryKey';

const MIN_LOADING_TIME = 2500;

export const useSuggestedMetricsQuery = ({
  enabled,
  onSettled,
  onSuccess,
}: {
  enabled: boolean;
  onSuccess: (data: string[]) => void;
  onSettled: (error: Error | null) => void;
}) => {
  const query = useQuery({
    queryKey: preferencesQueryKey.suggestedMetrics(),
    queryFn: withMinimalLoading(preferencesApi.getSuggestedMetrics, MIN_LOADING_TIME),
    enabled,
  });

  useEffect(() => {
    if (query.data) {
      onSuccess(query.data);
    }
  }, [query.data]);

  useEffect(() => {
    if (query.isFetched) {
      onSettled(query.error);
    }
  }, [query.isFetched]);

  return query;
};
